import { useRoute } from "eddev/routing"
import { useSnapshot } from "valtio"
import { SearchInputStore, SearchState, searchStore } from "./search-system"

/**
 * This hook takes key/change events, and returns a store containing the search input state.
 * It allows the user to type things, but debounces key press events so that we aren't spamming the search API.
 */
export function useSearchInput(): SearchInputStore {
  return useSnapshot(searchStore.state.input, {
    sync: true,
  })
}

export function useSearch() {
  return useSnapshot(searchStore.state) as SearchState
}
